const HaloPlugin = {
    id: 'haloEffect',
    //We use "afterDatasetsDraw" to ensure datasets are already visible, and to make sure it draws on top of the target
    afterDatasetsDraw: (chart, args, options) => {
        const {ctx} = chart;
        const { haloDatasetId, haloColor, haloBlur, haloOffsetX, haloOffsetY} = options; //Plugin's parameters
        if(!haloDatasetId) {    //The datasetID is the target dataset for the effect
            return;
        }

        chart.data.datasets.forEach((dataset, datasetIndex) => {
            if(dataset.id === haloDatasetId) {
                const meta = chart.getDatasetMeta(datasetIndex);

                meta.data.forEach((barElement, dataIndex) => {
                    if(barElement.hidden || barElement.width <= 0) {
                        return;
                    }

                    ctx.save();

                    //Configures the properties
                    ctx.shadowColor = haloColor || 'rgba(255, 215, 0, 0.01)'; //Yellow as default
                    ctx.shadowBlur = haloBlur !== undefined ? haloBlur : 30;
                    ctx.shaddowOffsetX = haloOffsetX !== undefined ? haloOffsetX : 0;
                    ctx.shaddowOffsetY = haloOffsetY !== undefined ? haloOffsetY : 0;

                    //Adjust the size of the "halo" so it outstands the target
                    const expand = haloBlur / 2;

                    const x = barElement.base - expand;
                    const y = barElement.y - barElement.height / 2 - expand;
                    const width = (barElement.x - barElement.base) + (2 * expand);
                    const height = barElement.height + (2 * expand);
                    
                    //console.log(x, y, width, height);

                    //It's necessary to set a backgroundColor for rendering, if the color is 'transparent', it won't render.
                    //const barColor = dataset.backgroundColor[dataIndex] || dataset.backgroundColor;   //Can be applied to fillStyle, but we just need it to be yellow right now
                    ctx.fillStyle = 'rgba(255, 215, 0, .6)'; //Sets a low opacity to avoid visual interference with the target

                    //Draw the rectangle
                    ctx.fillRect(x, y, width, height);

                    ctx.restore();
                })
            }
        });
    }
};

export default HaloPlugin;